import React, { FC } from 'react';
import { Row } from 'react-table';
import { useDispatch, useSelector } from 'react-redux';

import { leasesSelector } from 'core/redux/selectors/tep';
import { actions as leasesActions } from 'core/redux/api/veta/tep/leases';
import { IndeterminateCheckbox } from 'components/organisms/sticky-table/row-select-checkbox';

import { ITepEntryPass } from 'types/tep';

interface IIndeterminateCheckboxProps {
  rows: Row<ITepEntryPass>[];
}

export const RowSelectHeader: FC<IIndeterminateCheckboxProps> = ({ rows }) => {
  const dispatch = useDispatch();

  const { selected } = useSelector(leasesSelector);

  const allIds = rows.map((row) => row.id);
  const selectedIds = selected.map(({ id }) => String(id));
  const isChecked = allIds.every((id) => selectedIds.includes(id));

  const onChange = () => {
    if (isChecked) {
      const updatedSelected = selected.filter(({ id }) => !allIds.includes(String(id)));

      dispatch(leasesActions.select({ leases: updatedSelected || [] }));
    } else {
      const updatedSelected = [...selected, ...rows.map(({ original }) => original)];

      dispatch(leasesActions.select({ leases: updatedSelected || [] }));
    }
  };

  return (
    <div>
      <IndeterminateCheckbox isHeader isChecked={isChecked} onChange={onChange} />
    </div>
  );
};
